import {
  Box,
  Flex,
  IconButton,
  Heading,
  Stack,
  Button,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Grid,
  GridItem,
  Input,
  Text,
  RadioGroup,
  Radio,
  Switch,
  Center,
  Textarea,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import {
  AiOutlineArrowLeft,
  AiOutlineEdit,
  AiOutlineSave,
  AiOutlineEye,
} from 'react-icons/ai';
import { useHistory, useParams } from 'react-router-dom';
import EditorComponent from '../../../../components/Admin/Editor';
import SidebarWithHeader from '../../../../components/Admin/SidebarWithHeader';
import BoxUploadFile from '../../../../components/Admin/UploadFile/BoxUploadFile';
import ManajemenPengetahuanContext, {
  useManajemenPengetahuanContext,
} from '../../../../controller/admin/manajemen_pengetahuan';
import YoutubeContext, {
  useYoutubeContext,
} from '../../../../controller/youtube/index';
import KelolaKontenManajemenPelatihanController, {
  useKelolaKontenManajemenPelatihanContext,
} from '../../../../controller/admin/manajemen_pelatihan/kelola_konten';
import DaftarPesertaPengetahuan from '../../../../components/Admin/Pengetahuan/DaftarPeserta';
import ManajemenPengetahuanDaftarPesertaController from '../../../../controller/admin/manajemen_pengetahuan/daftar-peserta';
import Select, { StylesConfig } from 'react-select';
import ButtonModalDelete from '../../../../components/Admin/Pengetahuan/ButtonModalDelete';
import { useRole } from '../../../../../hooks/useRole';
import Loader from '../../../../components/Loader';
import KontenPemateri from '../../../../components/Admin/Pengetahuan/KontenPemateri';
import ManajemenPengetahuanKontenPemateriContext from '../../../../controller/admin/manajemen_pengetahuan/konten-pemateri';
import ModalAddSpeaker from '../../../../components/Admin/ModalPengetahuan/ModalAddSpeaker';
import { useToast } from '@chakra-ui/react';
import Pendaftar from '../../../../components/Admin/Pengetahuan/Pendaftar';
import ManajemenPengetahuanPendaftarController from '../../../../controller/admin/manajemen_pengetahuan/pendaftar/index';
import MasterTTEContext from '../../../../controller/admin/data_master/tte';

const DetailPengetahuan = () => {
  const history = useHistory();
  const { id } = useParams() as { id: string };
  const { canMutate } = useRole();

  const { getListVideo } = useYoutubeContext();
  const { listVideo } = useYoutubeContext().state;
  const { getPaketSoal } = useKelolaKontenManajemenPelatihanContext();

  const [tabIndexMenu, setTabIndexMenu] = useState(0);

  const {
    publish,
    image,

    description,
    loadingData,
    mode,
    title,
    organizer,
    kategoriPengetahuanId,
    listKategoriPengetahuan,
    loadingAction,
    type,
    startDate,
    endDate,
    jam_pelajaran,
    pengetahuanItem,
    is_klinik_khusus,
    listKategoriKlinikKhusus,
    kategoriKlinikKhusus,
    pelatihanSelected,
    search_pelatihan,
    listPelatihan,
    listPengetahuanUtama,
    pengetahuanUtamaSelected,
    review_url,
    isKlinikKhususServer,
    isKategoriKlinikServer,
    customSertifikat,
    keteranganSertifikat,
    jenisPersyaratan,
    tipe_klinik_khusus_mandiri,
    prasyarat_klinik_khusus_mandiri,
    listTipeMandiri,
    listPrasyaratMandiri,
  } = useManajemenPengetahuanContext().state;
  const {
    postData,
    setManajemenPengetahuanState,
    getDetailPengetahuan,
    getListKategoriPengetahuan,
    getPelatihanRelevan,
    getPengetahuanUtama,
    getListTipeMandiri,
    getListPrasyaratMandiri,
  } = useManajemenPengetahuanContext();

  const tipeKlinikMandiriRaw =
    (pengetahuanItem as any)?.tipe_klinik_khusus_mandiri ||
    (pengetahuanItem as any)?.pengetahuan_mandiri_prasyarat?.[0]?.type;
  const selectedTipeMandiri =
    tipe_klinik_khusus_mandiri ??
    (tipeKlinikMandiriRaw
      ? {
          value: tipeKlinikMandiriRaw,
          label: tipeKlinikMandiriRaw,
        }
      : null);

  const toast = useToast();
  const listOptionVideoYoutube = listVideo.map((item) => ({
    value: item.videoId,
    label: item.title,
  }));

  useEffect(() => {
    const fetchAllData = async () => {
      setManajemenPengetahuanState('loadingData', true);
      await getListVideo(); // Wait for getListVideo to complete
      await getListKategoriPengetahuan(); // Wait for getListKategoriPengetahuan to complete
      await getListTipeMandiri(); // Ensure tipe mandiri options are loaded early
      getPaketSoal();
      getDetailPengetahuan(id);
    };

    fetchAllData(); // Call the async function
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]); // Add dependencies as needed

  useEffect(() => {
    if (listKategoriPengetahuan) {
      const kategoriPengetahuanIdSelected = listKategoriPengetahuan.find(
        (item) => item.value === pengetahuanItem?.kategori_pengetahuan_id
      );
      setManajemenPengetahuanState(
        'kategoriPengetahuanId',
        kategoriPengetahuanIdSelected
      );

      console.log('run effect listKategoriPengetahuan');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listKategoriPengetahuan, pengetahuanItem?.kategori_pengetahuan_id]);

  useEffect(() => {
    if (
      listVideo &&
      pengetahuanItem?.category === 'video' &&
      pengetahuanItem?.path_file
    ) {
      const videoSelected = listOptionVideoYoutube.find(
        (item) => item.value === pengetahuanItem?.path_file
      );
      setManajemenPengetahuanState('youtubeVideoSelected', videoSelected);
      console.log('run effect listOptionVideoYoutube');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listVideo, pengetahuanItem?.path_file, pengetahuanItem?.category]);

  const colourStyles: StylesConfig<any, boolean> = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        backgroundColor: '#F6F5F8',
        padding: '2px 8px',
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        zIndex: 100,
      };
    },
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      const color = '#38A169';

      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? color
          : isFocused
          ? '#C6F6D5'
          : undefined,
        color: isDisabled ? 'white' : isSelected ? 'white' : 'black',

        cursor: isDisabled ? 'not-allowed' : 'default',

        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? 'white'
              : color
            : undefined,
          color: isDisabled ? 'white' : isSelected ? 'black' : 'white',
        },
      };
    },
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles }),
    singleValue: (styles, { data }) => ({ ...styles }),
  };

  useEffect(() => {
    const fetchPelatihanRelevan = async () => {
      if (!kategoriKlinikKhusus) return;
      if (kategoriKlinikKhusus?.value === 'UTAMA') {
        setManajemenPengetahuanState('review_url', '');
        await getPelatihanRelevan();
        await getListTipeMandiri();
      } else {
        await getPengetahuanUtama();
      }
    };
    fetchPelatihanRelevan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kategoriKlinikKhusus]);

  useEffect(() => {
    if (is_klinik_khusus === true && type === 'asynchronized') {
      setManajemenPengetahuanState('is_klinik_khusus', false);
      toast({
        title: 'Klinik Khusus hanya tersedia untuk Pengetahuan Synchronized',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_klinik_khusus]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (kategoriKlinikKhusus?.value === 'UTAMA') {
        getPelatihanRelevan(search_pelatihan);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search_pelatihan]);

  useEffect(() => {
    if (jenisPersyaratan !== 'mandiri') {
      return;
    }

    if (!tipe_klinik_khusus_mandiri?.value || !listTipeMandiri.length) {
      return;
    }

    const tipeSelected = listTipeMandiri.find(
      (item) => item.value === tipe_klinik_khusus_mandiri.value
    );

    if (
      tipeSelected &&
      (tipe_klinik_khusus_mandiri.label !== tipeSelected.label ||
        tipe_klinik_khusus_mandiri.value !== tipeSelected.value)
    ) {
      setManajemenPengetahuanState('tipe_klinik_khusus_mandiri', tipeSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    jenisPersyaratan,
    listTipeMandiri,
    tipe_klinik_khusus_mandiri?.label,
    tipe_klinik_khusus_mandiri?.value,
  ]);

  useEffect(() => {
    if (jenisPersyaratan !== 'mandiri') {
      return;
    }

    if (tipe_klinik_khusus_mandiri?.value) {
      return;
    }

    const tipeFromDetail = tipeKlinikMandiriRaw;
    if (!tipeFromDetail) {
      return;
    }

    const tipeSelected = listTipeMandiri.find(
      (item) => item.value === tipeFromDetail
    );

    setManajemenPengetahuanState(
      'tipe_klinik_khusus_mandiri',
      tipeSelected ?? { value: tipeFromDetail, label: tipeFromDetail }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    jenisPersyaratan,
    listTipeMandiri,
    tipeKlinikMandiriRaw,
    tipe_klinik_khusus_mandiri?.value,
  ]);

  return (
    <SidebarWithHeader spacing={false}>
      <Box
        p={4}
        bg="#EDF2F7"
        boxShadow="0px 10px 15px -3px rgba(15, 23, 42, 0.08)"
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Flex justifyContent="center" alignItems="center">
            <IconButton
              aria-label="Previous Page"
              icon={<AiOutlineArrowLeft />}
              fontSize="md"
              mr={2}
              onClick={() => history.push('/admin/manajemen_pengetahuan')}
            />
            <Heading
              as="h2"
              fontSize="md"
              fontWeight="bold"
              lineHeight="normal"
            >
              Pengetahuan {title}
            </Heading>
          </Flex>

          {tabIndexMenu === 0 && canMutate && (
            <Stack direction="row" spacing={2}>
              <Button
                colorScheme="orange"
                rightIcon={
                  mode === 'edit' ? (
                    <AiOutlineEye color="white" size={16} />
                  ) : (
                    <AiOutlineEdit color="white" size={16} />
                  )
                }
                onClick={() => {
                  if (mode === 'edit') {
                    setManajemenPengetahuanState('mode', 'view');
                  }
                  if (mode === 'view') {
                    setManajemenPengetahuanState('mode', 'edit');
                  }
                }}
              >
                {mode === 'edit' ? 'View' : 'Edit'}
              </Button>
              <ButtonModalDelete title={title} id={id} />
              <Button
                colorScheme="green"
                rightIcon={<AiOutlineSave color="white" size={16} />}
                isLoading={loadingAction}
                spinnerPlacement="start"
                loadingText="Menyimpan..."
                onClick={() => postData()}
                isDisabled={mode === 'view' || loadingData}
              >
                Simpan
              </Button>
            </Stack>
          )}
        </Flex>
      </Box>
      <Box>
        <Tabs
          variant="unstyled"
          color="black"
          mt={4}
          mx={4}
          index={tabIndexMenu}
          onChange={(index) => setTabIndexMenu(index)}
        >
          <TabList bg="transparent" borderTopRadius="lg" pt={2}>
            <Tab
              bg={tabIndexMenu === 0 ? 'white' : '#E5E7EB'}
              roundedTop="lg"
              mr={2}
            >
              Detail Pengetahuan
            </Tab>
            {isKlinikKhususServer && isKategoriKlinikServer === 'UTAMA' && (
              <Tab
                bg={tabIndexMenu === 1 ? 'white' : '#E5E7EB'}
                roundedTop="lg"
                mr={2}
              >
                Pendaftar
              </Tab>
            )}
            <Tab
              bg={
                tabIndexMenu ===
                (isKlinikKhususServer && isKategoriKlinikServer === 'UTAMA'
                  ? 2
                  : 1)
                  ? 'white'
                  : '#E5E7EB'
              }
              roundedTop="lg"
              mr={2}
            >
              Daftar Peserta
            </Tab>
            {(!isKlinikKhususServer ||
              (isKlinikKhususServer && isKategoriKlinikServer === 'SUB')) && (
              <Tab
                bg={
                  tabIndexMenu ===
                  (isKlinikKhususServer && isKategoriKlinikServer === 'UTAMA'
                    ? 3
                    : 2)
                    ? 'white'
                    : '#E5E7EB'
                }
                roundedTop="lg"
              >
                Konten Pemateri
              </Tab>
            )}
          </TabList>
          <TabPanels>
            <TabPanel p={0} pb={5}>
              <Grid
                templateColumns="repeat(6, 1fr)"
                py={8}
                gap={4}
                px={4}
                boxShadow="lg"
                bg="white"
              >
                {loadingData ? (
                  <GridItem colSpan={6} w="full">
                    <Loader />
                  </GridItem>
                ) : (
                  <>
                    {/* judul */}
                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Judul
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <Input
                        onChange={(e) =>
                          setManajemenPengetahuanState('title', e.target.value)
                        }
                        fontSize="sm"
                        value={title}
                        readOnly={mode === 'view'}
                        bg="#F6F5F8"
                        _focus={{
                          ring: '1',
                          ringColor: 'green',
                          borderColor: 'green',
                        }}
                      />
                    </GridItem>

                    {/* Sync/Async */}
                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Jenis Pengetahuan
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <RadioGroup
                        defaultValue={type}
                        onChange={(e) =>
                          setManajemenPengetahuanState('type', e)
                        }
                      >
                        <Stack spacing={5} direction="row">
                          <Radio
                            colorScheme="green"
                            value="synchronized"
                            isDisabled={mode === 'view'}
                          >
                            Synchronized
                          </Radio>
                          <Radio
                            colorScheme="green"
                            value="asynchronized"
                            isDisabled={mode === 'view'}
                          >
                            Asynchronized
                          </Radio>
                        </Stack>
                      </RadioGroup>
                    </GridItem>

                    {type === 'synchronized' && (
                      <>
                        {/* Jadwal Pengetahuan */}
                        <GridItem colSpan={1}>
                          <Text fontWeight="semibold" fontSize="sm">
                            Jadwal Pengetahuan
                          </Text>
                        </GridItem>
                        <GridItem colSpan={2} display="flex">
                          <Input
                            defaultValue={startDate}
                            type="datetime-local"
                            onChange={(e) =>
                              setManajemenPengetahuanState(
                                'startDate',
                                e.target.value
                              )
                            }
                            bg="#F6F5F8"
                            isReadOnly={mode === 'view'}
                            // w="30%"
                            _focus={{
                              ring: '1',
                              ringColor: 'green',
                              borderColor: 'green',
                            }}
                          />
                        </GridItem>
                        <GridItem
                          colSpan={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Text fontWeight="semibold" fontSize="sm">
                            SD
                          </Text>
                        </GridItem>
                        <GridItem colSpan={2} display="flex">
                          <Input
                            defaultValue={endDate}
                            type="datetime-local"
                            onChange={(e) =>
                              setManajemenPengetahuanState(
                                'endDate',
                                e.target.value
                              )
                            }
                            bg="#F6F5F8"
                            isReadOnly={mode === 'view'}
                            _focus={{
                              ring: '1',
                              ringColor: 'green',
                              borderColor: 'green',
                            }}
                          />
                        </GridItem>
                        {/* Jam Pelajaran */}
                        <GridItem colSpan={1}>
                          <Text fontWeight="semibold" fontSize="sm">
                            Jam Pelajaran
                          </Text>
                        </GridItem>
                        <GridItem colSpan={5}>
                          <Input
                            onChange={(e) =>
                              setManajemenPengetahuanState(
                                'jam_pelajaran',
                                e.target.value
                              )
                            }
                            fontSize="sm"
                            value={jam_pelajaran || ''}
                            bg="#F6F5F8"
                            placeholder="Masukkan jam pelajaran"
                            isReadOnly={mode === 'view'}
                            _focus={{
                              ring: '1',
                              ringColor: 'green',
                              borderColor: 'green',
                            }}
                          />
                        </GridItem>
                      </>
                    )}

                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Penyelenggara
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <Input
                        onChange={(e) =>
                          setManajemenPengetahuanState(
                            'organizer',
                            e.target.value
                          )
                        }
                        fontSize="sm"
                        value={organizer}
                        bg="#F6F5F8"
                        isReadOnly={mode === 'view'}
                        _focus={{
                          ring: '1',
                          ringColor: 'green',
                          borderColor: 'green',
                        }}
                      />
                    </GridItem>
                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Pilih Kategori
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <Select
                        placeholder="Pilih Kategori"
                        options={listKategoriPengetahuan}
                        isClearable
                        onChange={(e) =>
                          setManajemenPengetahuanState(
                            'kategoriPengetahuanId',
                            e
                          )
                        }
                        isDisabled={mode === 'view'}
                        value={kategoriPengetahuanId}
                        styles={colourStyles}
                      />
                    </GridItem>

                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Klinik Khusus
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <RadioGroup
                        value={String(is_klinik_khusus)}
                        onChange={(e) => {
                          const isKlinikKhusus = e === 'true';
                          setManajemenPengetahuanState(
                            'is_klinik_khusus',
                            isKlinikKhusus
                          );

                          if (!isKlinikKhusus) {
                            setManajemenPengetahuanState(
                              'kategoriKlinikKhusus',
                              null
                            );
                            setManajemenPengetahuanState(
                              'pengetahuanUtamaSelected',
                              null
                            );
                            setManajemenPengetahuanState('jenisPersyaratan', '');
                            setManajemenPengetahuanState('pelatihanSelected', []);
                            setManajemenPengetahuanState(
                              'pelatihanPrasyaratSelected',
                              []
                            );
                            setManajemenPengetahuanState(
                              'tipe_klinik_khusus_mandiri',
                              null
                            );
                            setManajemenPengetahuanState(
                              'prasyarat_klinik_khusus_mandiri',
                              []
                            );
                            setManajemenPengetahuanState(
                              'listPrasyaratMandiri',
                              []
                            );
                          }
                        }}
                      >
                        <Stack spacing={5} direction="row">
                          <Radio
                            colorScheme="green"
                            value="true"
                            isDisabled={mode === 'view'}
                          >
                            Ya
                          </Radio>
                          <Radio
                            colorScheme="green"
                            value="false"
                            isDisabled={mode === 'view'}
                          >
                            Tidak
                          </Radio>
                        </Stack>
                      </RadioGroup>
                    </GridItem>
                    {is_klinik_khusus && (
                      <>
                        <GridItem colSpan={1}>
                          <Text fontWeight="semibold" fontSize="sm">
                            Kategori Klinik Khusus
                          </Text>
                        </GridItem>
                        <GridItem colSpan={5}>
                          <Select<{ label: string; value: string }, false>
                            placeholder="Pilih Kategori"
                            options={listKategoriKlinikKhusus}
                            isClearable
                            onChange={(e) => {
                              setManajemenPengetahuanState(
                                'kategoriKlinikKhusus',
                                e
                              );

                              if (e?.value !== 'UTAMA') {
                                setManajemenPengetahuanState(
                                  'jenisPersyaratan',
                                  ''
                                );
                                setManajemenPengetahuanState(
                                  'pelatihanSelected',
                                  []
                                );
                                setManajemenPengetahuanState(
                                  'pelatihanPrasyaratSelected',
                                  []
                                );
                                setManajemenPengetahuanState(
                                  'tipe_klinik_khusus_mandiri',
                                  null
                                );
                                setManajemenPengetahuanState(
                                  'prasyarat_klinik_khusus_mandiri',
                                  []
                                );
                                setManajemenPengetahuanState(
                                  'listPrasyaratMandiri',
                                  []
                                );
                              }
                            }}
                            value={kategoriKlinikKhusus}
                            styles={colourStyles}
                            isDisabled={mode === 'view'}
                          />
                        </GridItem>

                        {type === 'synchronized' &&
                          kategoriKlinikKhusus?.value === 'UTAMA' && (
                          <>
                            <GridItem colSpan={1}>
                              <Text fontWeight="semibold" fontSize="sm">
                                Jenis Persyaratan
                              </Text>
                            </GridItem>
                            <GridItem colSpan={5}>
                              <RadioGroup
                                value={jenisPersyaratan}
                                onChange={(e) => {
                                  setManajemenPengetahuanState(
                                    'jenisPersyaratan',
                                    e
                                  );
                                  setManajemenPengetahuanState(
                                    'pelatihanSelected',
                                    []
                                  );
                                  setManajemenPengetahuanState(
                                    'pelatihanPrasyaratSelected',
                                    []
                                  );
                                  setManajemenPengetahuanState(
                                    'tipe_klinik_khusus_mandiri',
                                    null
                                  );
                                  setManajemenPengetahuanState(
                                    'prasyarat_klinik_khusus_mandiri',
                                    []
                                  );
                                  setManajemenPengetahuanState(
                                    'listPrasyaratMandiri',
                                    []
                                  );
                                }}
                              >
                                <Stack spacing={5} direction="row">
                                  <Radio
                                    colorScheme="green"
                                    value="pendalaman_pelatihan"
                                    isDisabled={mode === 'view'}
                                  >
                                    Pendalaman Pelatihan
                                  </Radio>
                                  <Radio
                                    colorScheme="green"
                                    value="mandiri"
                                    isDisabled={mode === 'view'}
                                  >
                                    Mandiri
                                  </Radio>
                                </Stack>
                              </RadioGroup>
                            </GridItem>

                            {jenisPersyaratan === 'pendalaman_pelatihan' && (
                              <>
                                <GridItem colSpan={1}></GridItem>
                                <GridItem colSpan={5}>
                                  <Select
                                    options={listPelatihan}
                                    onChange={(e) => {
                                      setManajemenPengetahuanState(
                                        'pelatihanSelected',
                                        e
                                      );
                                      setManajemenPengetahuanState(
                                        'pelatihanPrasyaratSelected',
                                        e ?? []
                                      );
                                    }}
                                    onInputChange={(inputValue) => {
                                      setManajemenPengetahuanState(
                                        'search_pelatihan',
                                        inputValue
                                      );
                                    }}
                                    value={pelatihanSelected}
                                    isMulti={true}
                                    placeholder="Pilih Pelatihan Relevan"
                                    isDisabled={mode === 'view'}
                                  />
                                </GridItem>
                              </>
                            )}

                            {jenisPersyaratan === 'mandiri' && (
                              <>
                                <GridItem colSpan={1}>
                                  <Text fontWeight="semibold" fontSize="sm">
                                    Tipe Prasyarat
                                  </Text>
                                </GridItem>
                                <GridItem colSpan={5}>
                                  <Select
                                    placeholder="Pilih Tipe Prasyarat"
                                    options={listTipeMandiri}
                                    isClearable
                                    onChange={(e: any) => {
                                      setManajemenPengetahuanState(
                                        'tipe_klinik_khusus_mandiri',
                                        e
                                      );
                                      setManajemenPengetahuanState(
                                        'prasyarat_klinik_khusus_mandiri',
                                        []
                                      );
                                      if (e?.value) {
                                        getListPrasyaratMandiri(e.value);
                                      }
                                    }}
                                    value={selectedTipeMandiri}
                                    styles={colourStyles}
                                    isDisabled={mode === 'view'}
                                  />
                                </GridItem>

                                {tipe_klinik_khusus_mandiri && (
                                  <>
                                    <GridItem colSpan={1}></GridItem>
                                    <GridItem colSpan={5}>
                                      <Select
                                        placeholder="Pilih Prasyarat"
                                        options={listPrasyaratMandiri}
                                        isMulti
                                        onChange={(e) =>
                                          setManajemenPengetahuanState(
                                            'prasyarat_klinik_khusus_mandiri',
                                            e
                                          )
                                        }
                                        value={
                                          prasyarat_klinik_khusus_mandiri
                                        }
                                        styles={colourStyles}
                                        isDisabled={mode === 'view'}
                                      />
                                    </GridItem>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}

                        {kategoriKlinikKhusus?.value === 'SUB' && (
                          <>
                            <GridItem colSpan={1}></GridItem>
                            <GridItem colSpan={5}>
                              <Select
                                options={listPengetahuanUtama}
                                onChange={(e) => {
                                  setManajemenPengetahuanState(
                                    'pengetahuanUtamaSelected',
                                    e
                                  );
                                }}
                                value={pengetahuanUtamaSelected}
                                placeholder="Pilih Tema Utama"
                                isDisabled={mode === 'view'}
                              />
                            </GridItem>
                          </>
                        )}
                      </>
                    )}

                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Cover Thumbnail
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <BoxUploadFile
                        setFile={setManajemenPengetahuanState}
                        typeFile="image"
                        defaultFile={image}
                        isReadOnly={mode === 'view'}
                      />
                    </GridItem>

                    {/* Informasi Umum */}
                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Informasi Umum
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <Box pointerEvents={mode === 'view' ? 'none' : 'auto'}>
                        <EditorComponent
                          description={description}
                          setDescription={setManajemenPengetahuanState}
                        />
                      </Box>
                    </GridItem>

                    {/* Kuisioner */}
                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        kuesioner
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5}>
                      <Input
                        placeholder="Masukan Link Kuesioner"
                        onChange={(e) =>
                          setManajemenPengetahuanState(
                            'review_url',
                            e.target.value
                          )
                        }
                        fontSize="sm"
                        value={review_url}
                        readOnly={mode === 'view'}
                        isDisabled={
                          is_klinik_khusus &&
                          kategoriKlinikKhusus?.value === 'UTAMA'
                        }
                        bg="#F6F5F8"
                        _focus={{
                          ring: '1',
                          ringColor: 'green',
                          borderColor: 'green',
                        }}
                      />
                    </GridItem>
                     {/* Divider */}
                    <GridItem colSpan={6}>
                      <Box borderBottom="1px solid #E2E8F0" my={2} />
                    </GridItem>

                    {/* Custom Sertifikat */}
                    <GridItem colSpan={6}>
                      <Text fontWeight="semibold" fontSize="sm" mb={4}>
                        Custom Sertifikat
                      </Text>
                      <Grid templateColumns="repeat(6, 1fr)" gap={4}>
                        <GridItem colSpan={1}>
                          <Text fontWeight="medium" fontSize="sm">
                            File Design Sertifikat
                          </Text>
                        </GridItem>
                        <GridItem colSpan={5}>
                          <BoxUploadFile
                            setFile={setManajemenPengetahuanState}
                            typeFile="image"
                            defaultFile={customSertifikat}
                            isReadOnly={mode === 'view'}
                            nameFile="customSertifikat"
                            uniqueId="certificate"
                          />
                        </GridItem>

                        <GridItem colSpan={1}>
                          <Text fontWeight="medium" fontSize="sm">
                            Keterangan Tambahan
                          </Text>
                        </GridItem>
                        <GridItem colSpan={5}>
                          <Textarea
                            placeholder="Masukkan keterangan tambahan untuk sertifikat"
                            onChange={(e) =>
                              setManajemenPengetahuanState(
                                'keteranganSertifikat',
                                e.target.value
                              )
                            }
                            fontSize="sm"
                            value={keteranganSertifikat}
                            readOnly={mode === 'view'}
                            rows={4}
                          />
                        </GridItem>
                      </Grid>
                    </GridItem>

                    {/* Divider */}
                    <GridItem colSpan={6}>
                      <Box borderBottom="1px solid #E2E8F0" my={2} />
                    </GridItem>

                    {/* Publikasi */}
                    <GridItem colSpan={1}>
                      <Text fontWeight="semibold" fontSize="sm">
                        Publikasi
                      </Text>
                    </GridItem>
                    <GridItem colSpan={5} display="flex">
                      <Switch
                        defaultChecked={publish}
                        colorScheme="green"
                        mr={2}
                        isReadOnly={mode === 'view'}
                        onChange={(e) =>
                          setManajemenPengetahuanState(
                            'publish',
                            e.target.checked
                          )
                        }
                      />
                      <Text fontWeight="semibold" fontSize="sm">
                        {publish ? 'Publikasi' : 'Draft'}
                      </Text>
                    </GridItem>
                  </>
                )}
              </Grid>
            </TabPanel>
            {isKlinikKhususServer && isKategoriKlinikServer === 'UTAMA' && (
              <TabPanel p={0}>
                <Pendaftar />
              </TabPanel>
            )}
            <TabPanel p={0}>
              <DaftarPesertaPengetahuan
                isKlinikKhususServer={isKlinikKhususServer}
                isKategoriKlinikServer={isKategoriKlinikServer}
                type={type}
              />
            </TabPanel>
            {(!isKlinikKhususServer ||
              (isKlinikKhususServer && isKategoriKlinikServer === 'SUB')) && (
              <TabPanel p={0}>
                {pengetahuanItem ? (
                  <KontenPemateri />
                ) : (
                  <Center>
                    <Loader />
                  </Center>
                )}
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </Box>

      <ModalAddSpeaker />
    </SidebarWithHeader>
  );
};

const DetailPengetahuanWrapper = () => {
  return (
    <ManajemenPengetahuanKontenPemateriContext>
      <ManajemenPengetahuanDaftarPesertaController.Provider>
        <ManajemenPengetahuanContext.Provider>
          <YoutubeContext.Provider>
            <KelolaKontenManajemenPelatihanController.Provider>
              <ManajemenPengetahuanPendaftarController.Provider>
                <MasterTTEContext.Provider>
                  <DetailPengetahuan />
                </MasterTTEContext.Provider>
              </ManajemenPengetahuanPendaftarController.Provider>
            </KelolaKontenManajemenPelatihanController.Provider>
          </YoutubeContext.Provider>
        </ManajemenPengetahuanContext.Provider>
      </ManajemenPengetahuanDaftarPesertaController.Provider>
    </ManajemenPengetahuanKontenPemateriContext>
  );
};

export default DetailPengetahuanWrapper;
